import { render, staticRenderFns } from "./task-overdue.vue?vue&type=template&id=e6b2f3de&scoped=true&"
import script from "./task-overdue.vue?vue&type=script&lang=js&"
export * from "./task-overdue.vue?vue&type=script&lang=js&"
import style0 from "./task-overdue.vue?vue&type=style&index=0&id=e6b2f3de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b2f3de",
  null
  
)

export default component.exports